import React from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import * as yup from 'yup';
import {useFormik} from 'formik';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import {signUp, useAuthDispatch} from '../../context'
import {useNavigate} from 'react-router-dom';
import InputAdornment from "@mui/material/InputAdornment";
import CountdownButton from "../UI/CountdownButton";
import Request from "../AxiosInstance";

export default function CompleteSignUpForm ({formState, handleBack}) {

	const dispatch = useAuthDispatch();
	const navigate = useNavigate();

	const validationSchema = yup.object({
		code: yup
			.string('')
			.required('Verification code is required')
	});

	const handleResendCode = async () => {
		await formik.setFieldValue('code', '');
		await Request.post('/auth/getrc', formState);
	}

	const formSubmit = async (formValue) => {

		const combinedFormValue = {
			...formState,
			code: formValue.code
		}

		try {
			await signUp(dispatch, combinedFormValue);
			navigate('/acc/setup');
		} catch (e) {
			console.error(e);
		}
	}

	const formik = useFormik({
		initialValues: formState,
		validationSchema: validationSchema,
		onSubmit: async (values) => {
			await formSubmit(values)
		},
	});

	return (
		<React.Fragment>
			<Typography variant="h6" align={"center"} sx={{ pt: 2, pb: 1 }}>
				Complete sign up
			</Typography>
			<Typography variant={"subtitle1"} sx={{ pb: 2 }}>
				Enter the verification code we sent to {formik.values.receiver}
			</Typography>
			<form onSubmit={formik.handleSubmit}>
				<Grid container spacing={3}>
					<Grid item xs={12}>
						<TextField
							required
							id="code"
							name="code"
							label="Verification Code"
							fullWidth
							inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
							value={formik.values.code}
							onChange={formik.handleChange}
							InputProps={{
								endAdornment:
									<InputAdornment position="end">
										<CountdownButton
											color="secondary"
											variant="outlined"
											text={'Resend'}
											initCounter={30}
											interval={60}
											handler={handleResendCode}
											helperText={"Didn't receive the code? Resend"}
										/>
									</InputAdornment>
							}}
						/>
					</Grid>
				</Grid>
				<Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
					<Button
						variant="outlined"
						color="warning"
						sx={{ mt: 3, ml: 1 }}
						onClick={handleBack}
					>
						Back
					</Button>
					<Button
						variant="contained"
						color="success"
						sx={{ mt: 3, ml: 1 }}
						type="submit"
					>
						Sign up
					</Button>
				</Box>
			</form>
		</React.Fragment>
	)
}